export default theme => {
    return {}
}


// WEBPACK FOOTER //
// ./src/app/configuration/Optimum/theme/components/scorecard/ScorecardView/ScorecardExport.js